import { MODES } from './constants';

// export const MODE = MODES.DEV;
export const MODE = MODES.PROD;

export const BASE_URL = MODE === MODES.PROD ? '' : 'http://localhost:8108';